<template>
  <el-dialog
    title="Добавить платежное лицо"
    :visible="visible"
    :close-on-click-modal="false"
    @update:visible="updateVisible"
    @open="handleDialogOpen">
    <el-form
      ref="form"
      :rules="rules"
      :model="formData"
      label-position="top"
      @submit.native.prevent="onSubmit">
      <el-form-item class="mt-12" label="Тип организации" prop="orgType">
        <el-select v-model="formData.orgType">
          <el-option
            v-for="type in orgTypes"
            :key="type.id"
            :label="type.label"
            :value="type.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="ИНН" prop="inn">
        <el-input v-model="formData.inn" name="inn" />
      </el-form-item>
      <el-form-item label="Название организации" prop="orgName">
        <el-input v-model="formData.orgName" name="orgName" />
      </el-form-item>
      <el-form-item label="Фактический адрес" prop="factAddress">
        <el-input v-model="formData.factAddress" name="factAddress" />
      </el-form-item>
      <el-form-item label="Юридический адрес" prop="legalAddress">
        <el-input v-model="formData.legalAddress" name="legalAddress" />
      </el-form-item>
      <el-form-item>
        <el-checkbox
          v-model="formData.isPrimary"
          label="Основное платежное лицо"
          name="isPrimary" />
      </el-form-item>
      <el-form-item>
        <el-radio-group v-model="formData.documentReceive">
          <el-radio label="mail">Получать документы на почту</el-radio>
          <el-radio label="edo">Получать документы по ЭДО</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="divider" />
      <div class="flex-x-center">
        <el-button
          :loading="$mip('createRequisite')"
          type="primary"
          native-type="submit">
          Добавить
        </el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import { clearFormData } from '@/utils'

  export default {
    props: {
      visible: Boolean,
      orgTypes: Array
    },

    data() {
      return {
        organizationTypes: [
          'Юридическое лицо',
          'Физическое лицо'
        ],
        rules: {
          orgType: [
            { required: true, message: 'Пожалуйста, выберите тип организации', trigger: 'blur' }
          ],
          inn: [
            { required: true, message: 'Пожалуйста, введите ИНН', trigger: 'blur' }
          ],
          orgName: [
            { required: true, message: 'Пожалуйста, введите название организации', trigger: 'blur' }
          ],
          factAddress: [
            { required: true, message: 'Пожалуйста, введите фактический адрес', trigger: 'blur' }
          ],
          legalAddress: [
            { required: true, message: 'Пожалуйста, введите юридический адрес', trigger: 'blur' }
          ]
        },
        formData: {
          orgType: '',
          inn: '',
          orgName: '',
          factAddress: '',
          legalAddress: '',
          isPrimary: false,
          documentReceive: 'mail'
        }
      }
    },

    methods: {
      handleDialogOpen() {
        this.formData = clearFormData(this.formData, { isPrimary: false, documentReceive: 'mail' })
      },

      onSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.createRequisite()
          } else {
            console.error('Error: form validation')
            return false
          }
        })
      },

      async createRequisite() {
        const { id, ...formWithoutId } = this.formData
        await this.$http.createRequisite(formWithoutId)
        this.updateVisible(false)

        this.$notify(
          {
            type: 'success',
            title: 'Создание лица',
            message: 'Платежное лицо создано'
          }
        )

        this.$emit('update-list')
      },

      updateVisible(val) {
        this.$emit('update:visible', val)
      }
    }
  }
</script>